import React, { useState } from 'react';
import { priorityMeta, statusMeta, STATUS_ORDER, TB_COLORS } from './utils';
import { TagPills, DueLabel, LocationLabel, Assignees } from './bits';

const Card = ({ task, areaMap, propertyName, onEdit }) => (
  <div
    draggable
    onDragStart={(e) => e.dataTransfer.setData('text/task-id', String(task.id))}
    onClick={() => onEdit(task)}
    style={{
      background: '#fff',
      border: '1px solid #eaecf0',
      borderTop: `3px solid ${priorityMeta(task.priority).color}`,
      borderRadius: 10,
      padding: 14,
      marginBottom: 12,
      cursor: 'pointer',
      boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
    }}
  >
    <div style={{ fontWeight: 600, fontSize: 14, color: TB_COLORS.text, marginBottom: 6 }}>{task.title}</div>
    <div style={{ marginBottom: 8 }}>
      <LocationLabel task={task} areaMap={areaMap} propertyName={propertyName} />
    </div>
    <div style={{ marginBottom: 10 }}>
      <TagPills tags={task.tags} max={2} />
    </div>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <DueLabel task={task} />
      <Assignees task={task} size={26} />
    </div>
  </div>
);

const BoardView = ({ tasks, areaMap, propertyName, onEdit, onChangeStatus }) => {
  const [dragOver, setDragOver] = useState(null);

  const byStatus = STATUS_ORDER.reduce((acc, s) => {
    acc[s] = tasks.filter((t) => t.status === s);
    return acc;
  }, {});
  // Any status not in the standard order (defensive) folds into To Do visually.
  const orphan = tasks.filter((t) => !STATUS_ORDER.includes(t.status));
  byStatus.todo = byStatus.todo.concat(orphan);

  const handleDrop = (e, status) => {
    e.preventDefault();
    setDragOver(null);
    const id = e.dataTransfer.getData('text/task-id');
    const task = tasks.find((t) => String(t.id) === String(id));
    if (task && task.status !== status) onChangeStatus(task, status);
  };

  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', overflowX: 'auto', paddingBottom: 8 }}>
      {STATUS_ORDER.map((status) => {
        const m = statusMeta(status);
        const list = byStatus[status] || [];
        return (
          <div
            key={status}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver(status);
            }}
            onDragLeave={() => setDragOver((s) => (s === status ? null : s))}
            onDrop={(e) => handleDrop(e, status)}
            style={{
              flex: '0 0 320px',
              maxWidth: 320,
              background: dragOver === status ? '#f0fdf4' : '#f9fafb',
              border: `1px solid ${dragOver === status ? m.accent : '#eaecf0'}`,
              borderTop: `3px solid ${m.accent}`,
              borderRadius: 12,
              padding: 12,
              minHeight: 200,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
              <span style={{ fontWeight: 700, fontSize: 15, color: TB_COLORS.text }}>{m.label}</span>
              <span style={{ color: TB_COLORS.subtext, fontWeight: 600 }}>{list.length}</span>
            </div>
            {list.map((task) => (
              <Card key={task.id} task={task} areaMap={areaMap} propertyName={propertyName} onEdit={onEdit} />
            ))}
            {list.length === 0 ? (
              <div style={{ color: '#98a2b3', fontSize: 13, textAlign: 'center', padding: '24px 0' }}>
                Drop tasks here
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default BoardView;
